import React from "react";
import Header from "../../../components/Header";
import style from "../../main/main.module.scss";
import localStyle from "./index.module.scss";
import BatchPicker from "../../main/components/BatchPicker";
import { Link } from "react-router-dom";
import List from "./components/List";
import { Icon } from "antd";

// 课程列表页面
function CourseList() {
    return (
        <div>
            <Header />
            <div className={style.root}>
                <div className={style.header}>
                    <BatchPicker />
                    <Link className={localStyle.scheduleLink} to={"/"}>
                        <Icon type="table" />
                        <span>课程表</span>
                    </Link>
                </div>

                <div className={localStyle.list}>
                    <List />
                </div>
            </div>
        </div>
    );
}

export default CourseList;
